import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/Home1.css";
import "font-awesome/css/font-awesome.min.css";
import { FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import data from "../../src/component/ApiUrl/meta_api";
// import videoSrc from "../assets/img/Home/Scimitar Automation.mp4";
import { useNavigate } from "react-router-dom";

function Home() {
  const [meta, setMeta] = useState(null);
  const navigate = useNavigate();

  const fetchData = () => {
    const HomeMeta = data[0]?.home_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  const [yearsExperience, setYearsExperience] = useState(0);
  const [teamMembers, setTeamMembers] = useState(0);
  const [happyClients, setHappyClients] = useState(0);
  const [projectsDone, setProjectsDone] = useState(0);

  const targetYearsExperience = 7;
  const targetTeamMembers = 22;
  const targetHappyClients = 50;
  const targetProjectsDone = 68;

  const duration = 3000;

  // Achivements Content
  const achivements_content = [
    {
      id: 1,
      title: "Years Experience",
      count: targetYearsExperience,
      content: `With over ${targetYearsExperience} years of experience, we deliver reliable technology solutions and automation services.`,
      src: require("../assets/img/Home/experience.png"),
    },

    {
      id: 2,
      title: "Team Members",
      count: targetTeamMembers,
      content:
        "Our skilled team members work together to provide innovative solutions and high-quality services.",
      src: require("../assets/img/Home/team-member.png"),
    },

    {
      id: 3,
      title: "Happy Clients",
      count: targetHappyClients,
      content: `We proudly serve more than ${targetHappyClients} happy clients by delivering trusted and result-driven technology solutions.`,
      src: require("../assets/img/Home/happy-client.png"),
    },

    {
      id: 4,
      title: "Projects Done",
      count: targetProjectsDone,
      content: `Successfully completed ${targetProjectsDone} projects with innovative strategies, advanced technology, and strong client satisfaction.`,
      src: require("../assets/img/Home/project-done.png"),
    },
  ];

  useEffect(() => {
    const countUp = (target, setCount) => {
      const totalSteps = target;
      const stepDuration = duration / totalSteps;
      let count = 0;

      const interval = setInterval(() => {
        if (count <= totalSteps) {
          setCount(count++);
        } else {
          clearInterval(interval);
        }
      }, stepDuration);

      return interval;
    };

    const intervalsArr = [
      countUp(targetYearsExperience, setYearsExperience),
      countUp(targetTeamMembers, setTeamMembers),
      countUp(targetHappyClients, setHappyClients),
      countUp(targetProjectsDone, setProjectsDone),
    ];

    return () => {
      intervalsArr.forEach((interval) => clearInterval(interval));
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Home"}</title>
      </Helmet>

      {/* Caresoul Banner */}
      <div className="container-fluid px-0 mb-5">
        <div
          id="header-carousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                className="w-100 object-fit-cover"
                src={require("../assets/img/Home/banner-2.jpg")}
                alt="Industrial Automation Training and Technical Services"
              />

              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-10 text-start">
                      <p className="fs-5 fw-medium text-red text-uppercase animated slideInRight">
                        Professional Technical Training & Industrial Services
                      </p>

                      <h1 className="display-1 text-white fs-1 mb-3 animated slideInRight">
                        Industrial Automation Training and Engineering Solutions
                      </h1>

                      <p className="text-white mb-4 animated slideInRight">
                        We provide professional industrial automation training
                        and engineering services to help students and
                        professionals develop practical technical skills and
                        real-world industry knowledge for modern manufacturing
                        environments.
                      </p>

                      <button
                        className="btn button-color py-3 px-5 animated slideInRight"
                        onClick={() => navigate("/about")}
                      >
                        Explore Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <img
                className="w-100 object-fit-cover"
                src={require("../assets/img/Home/banner-1.jpg")}
                alt="Automation Courses and Technical Skill Development"
              />

              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-10 text-start">
                      <p className="fs-5 fw-medium text-red text-uppercase animated slideInRight">
                        Learn Industry-Ready Technical Skills
                      </p>

                      <h1 className="display-1 text-white fs-1 mb-3 animated slideInRight">
                        Automation Courses, Workshops and Technical Support
                      </h1>

                      <p className="text-white mb-4 animated slideInRight">
                        Our expert trainers deliver hands-on training programs,
                        workshops and technical consulting services that prepare
                        students and professionals for real industrial
                        automation projects and career opportunities.
                      </p>

                      <button
                        href="#"
                        className="btn button-color py-3 px-5 animated slideInRight"
                        onClick={() => navigate("/about")}
                      >
                        Explore Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev arrow-left"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon arrow-color"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next arrow-right"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon arrow-color"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* Introduction start */}
      <div className="container margin_top">
        <div className="container">
          <div className="row g-5 align-items-center">
            {/* Image Section */}
            <div className="col-lg-6 col-md-12 order-2 order-lg-1 text-center">
              {/* Row 1 */}
              <div
                className="row g-3 justify-content-center"
                data-aos="zoom-in"
              >
                {/* Image 1 */}
                <div className="col-6 col-sm-6 mx-auto">
                  <img
                    className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                    src={require("../assets/img/Home/intro-1.jpg")}
                    alt="About 1"
                  />
                </div>

                {/* Image 2 & 3 (Hide only in Mobile) */}
                <div className="col-6 d-none d-sm-block">
                  <div className="row g-3 h-100">
                    <div className="col-12">
                      <img
                        className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                        src={require("../assets/img/Home/intro-2.jpg")}
                        alt="About 2"
                      />
                    </div>

                    <div className="col-12">
                      <img
                        className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                        src={require("../assets/img/Home/intro-3.jpg")}
                        alt="About 3"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 2 */}
              <div
                className="row g-3 mt-1 d-none d-lg-block"
                data-aos="zoom-out"
              >
                <div className="col-12">
                  <img
                    className="img-fluid rounded-4 w-100 object-fit-cover"
                    src={require("../assets/img/Home/intro-4.jpg")}
                    alt="About 4"
                  />
                </div>
              </div>
            </div>

            {/* Content Section */}
            <div
              className="col-lg-6 col-md-12 order-1 order-lg-2"
              data-aos="zoom-in"
            >
              <div className="section-header mb-2">
                <h2 className="section-title text-red">Introduction</h2>
              </div>

              <p className="mb-2 fs-6">
                <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
                is a forward-thinking technology company dedicated to bridging
                the gap between the physical and digital worlds. We deliver
                innovative, reliable, and scalable technology solutions that
                help businesses adapt to the rapidly evolving digital landscape.
                Our mission is to empower organizations with advanced
                technologies, smart automation, and sustainable growth.
              </p>

              <p className="mb-2 fs-6">
                At{" "}
                <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>
                , we follow a structured and customer-centric approach that
                focuses on quality, performance, and long-term value. Our team
                combines industry expertise, continuous innovation, and modern
                technological practices to create solutions that address
                real-world business challenges.
              </p>

              <p className="mb-3 fs-6">
                We are committed to helping businesses enhance operational
                efficiency, improve productivity, and achieve long-term success
                through technology-driven solutions.
              </p>

              {/* Experience Section */}
              <div className="row align-items-center mb-4">
                {/* Left Side */}
                <div className="col-4 col-md-3">
                  <div className="bg-secondary p-3 p-md-4 rounded text-center">
                    <h1 className="display-5 display-md-4 text-white mb-0">
                      7+
                    </h1>
                    <h6 className="text-white mb-0">Years of</h6>
                    <h6 className="text-white mb-0">Experience</h6>
                  </div>
                </div>

                {/* Right Side */}
                <div className="col-8 col-md-9">
                  <p className="mb-1">
                    <i className="fa fa-check text-yellow me-2"></i>
                    Industrial Automation
                  </p>

                  <p className="mb-1">
                    <i className="fa fa-check text-yellow me-2"></i>
                    Control Systems Design
                  </p>

                  <p className="mb-1">
                    <i className="fa fa-check text-yellow me-2"></i>
                    Maintenance & Support
                  </p>

                  <p className="mb-1">
                    <i className="fa fa-check text-yellow me-2"></i>
                    Consulting Services
                  </p>

                  <p className="mb-0">
                    <i className="fa fa-check text-yellow me-2"></i>
                    Energy Efficiency Solutions
                  </p>
                </div>
              </div>

              {/* Contact Section */}
              <div className="row g-3 pt-2">
                <div className="col-sm-7">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 btn-lg-square rounded-circle bg-red d-flex justify-content-center align-items-center">
                      <i className="fa fa-envelope-open text-white"></i>
                    </div>

                    <div className="ms-3">
                      <p className="mb-1 fs-6">Email us</p>
                      <h6 className="mb-0 fs-6">info@skimitarautomation.com</h6>
                    </div>
                  </div>
                </div>

                <div className="col-sm-5">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 btn-lg-square rounded-circle bg-red d-flex justify-content-center align-items-center">
                      <i className="fa fa-phone text-white"></i>
                    </div>

                    <div className="ms-3">
                      <p className="mb-1 fs-6">Call us</p>
                      <h6 className="mb-0 fs-6">+91-824 801 0909</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Introduction end */}

      {/* Facts Start */}
      {/* <div className="container-fluid bg-secondary facts my-5 p-5 facts_content">
        <div className="row g-5">
          <div className="col-md-6 col-xl-3 wow fadeIn" data-wow-delay="0.1s">
            <div className="text-center border p-5">
              <img
                className="facts_sectionIcon"
                src={require("../assets/img/Home/trustworthiness.png")}
                alt="Trustworthiness Icon"
              />
              <h1 className="display-2 text-white mb-0">{yearsExperience}</h1>
              <span className="fs-5 fw-semi-bold text-white">
                Years Experience
              </span>
            </div>
          </div>
          <div className="col-md-6 col-xl-3 wow fadeIn" data-wow-delay="0.3s">
            <div className="text-center border p-5">
              <img
                className="facts_sectionIcon"
                src={require("../assets/img/Home/team.png")}
                alt="Team Members Icon"
              />
              <h1 className="display-2 text-white mb-0">{teamMembers}</h1>
              <span className="fs-5 fw-semi-bold text-white">Team Members</span>
            </div>
          </div>
          <div className="col-md-6 col-xl-3 wow fadeIn" data-wow-delay="0.5s">
            <div className="text-center border p-5">
              <img
                className="facts_sectionIcon"
                src={require("../assets/img/Home/handshake.png")}
                alt="Happy Clients Icon"
              />
              <h1 className="display-2 text-white mb-0">{happyClients}</h1>
              <span className="fs-5 fw-semi-bold text-white">
                Happy Clients
              </span>
            </div>
          </div>
          <div className="col-md-6 col-xl-3 wow fadeIn" data-wow-delay="0.7s">
            <div className="text-center border p-5">
              <img
                className="facts_sectionIcon"
                src={require("../assets/img/Home/project-management.png")}
                alt="Projects Done Icon"
              />
              <h1 className="display-2 text-white mb-0">{projectsDone}</h1>
              <span className="fs-5 fw-semi-bold text-white">
                Projects Done
              </span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Acheviements */}
      <div className="container margin_top">
        <div className="row align-items-center g-4">
          {/* LEFT SIDE */}
          <div className="col-12 col-lg-6">
            <div className="section-header mb-3">
              <h2 className="section-title text-red">
                Our Experience &{" "}
                <span className="text-yellow">Achievements</span>
              </h2>
            </div>

            <p className="mb-3 fs-6">
              At{" "}
              <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>,
              our experience and achievements reflect our commitment to
              innovation, quality, and customer satisfaction. With several years
              of industry expertise, we have successfully delivered reliable
              technology and automation solutions to businesses across multiple
              sectors. Our skilled team focuses on providing efficient,
              scalable, and result-driven services that help organizations
              improve productivity and embrace digital transformation.
            </p>

            {/* IMAGES */}
            <div className="row g-3 mt-1 justify-content-center">
              <div className="col-6 d-none d-lg-block">
                <img
                  className="img-fluid rounded-4 w-100"
                  src={require("../assets/img/Home/project-4.jpg")}
                  alt="Achive 1"
                />
              </div>

              <div className="col-6">
                <img
                  className="img-fluid rounded-4 w-100"
                  src={require("../assets/img/Home/project-6.jpg")}
                  alt="Achive 2"
                />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-12 col-lg-6">
            <div className="row g-4 justify-content-center mt-md-3">
              {achivements_content.map((item, index) => (
                <div className="col-12 col-md-6" key={index}>
                  <div className="card text-center h-100 shadow-sm rounded-4">
                    <div className="card-body p-4 d-flex flex-column">
                      <div
                        className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                        style={{
                          width: "80px",
                          height: "80px",
                        }}
                      >
                        <img src={item.src} alt="" style={{ width: "50px" }} />
                      </div>

                      <h5 className="fw-bold mb-3">
                        {item.count}+ {item.title}
                      </h5>

                      <p className="text-muted mb-0 flex-grow-1">
                        {item.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* why Choose us */}
      <div className="container margin_top">
        <div className="row g-5 align-items-center">
          <div
            className="col-lg-6 col-md-12 col-sm-6 wow fadeIn"
            data-wow-delay="0.5s"
            data-aos="zoom-in"
          >
            <div className="section-header mb-2">
              <h2 className="section-title text-red">
                Why <span className="text-yellow">Choose Us</span>
              </h2>
            </div>
            <p className="mb-3 fs-6">
              <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
              is a trusted provider of industrial automation and technology
              solutions, delivering innovative systems designed to improve
              efficiency and productivity across multiple industries. Our team
              of experienced professionals specializes in automation systems,
              smart manufacturing solutions, and process optimization, helping
              businesses streamline operations and reduce operational costs. By
              using advanced technologies and industry best practices, we
              provide scalable solutions that support digital transformation and
              long-term business growth.
            </p>

            <p className="mb-2 fs-6">
              At{" "}
              <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>,
              we follow a customer-focused and results-driven approach to ensure
              every project meets the specific needs of our clients. From
              planning and system integration to implementation and continuous
              support, we deliver reliable automation solutions that enhance
              performance and operational efficiency. Our commitment to quality,
              innovation, and industrial excellence makes us a preferred partner
              for businesses seeking sustainable and technology-driven success.
            </p>
          </div>

          <div
            className="col-lg-6 col-md-12 col-sm-12 wow fadeInUp"
            data-wow-delay="0.1s"
            data-aos="fade-right"
          >
            <img
              className="img-fluid rounded-4 d-flex"
              src={require("../assets/img/images (19).jpg")}
              alt="Feature"
            />
          </div>
        </div>
      </div>

      {/* <section className="bg-light py-3 py-md-5 py-xl-8 service_cardSection mt-5">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
              <h2 className="mb-4 display-5 text-center text-white">
                Our Services
              </h2>
              <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row gy-3 gy-md-4">
            <div className="col-12 col-md-4 col-sm-6" data-aos="fade-right">
              <div className="card border-dark">
                <div className="card-body text-center p-4 p-xxl-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="currentColor"
                    className="bi bi-house text-red mb-4"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.004-.001.274-.11a.75.75 0 0 1 .558 0l.274.11.004.001zm-1.374.527L8 5.962 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339Z" />
                  </svg>
                  <h4 className="mb-4">Industrial Automation</h4>
                  <p className="mb-4 text-secondary fs-6">
                    Customized automation systems designed to streamline
                    production.
                  </p>
                  <a
                    href="#!"
                    className="btn btn-outline-danger bsb-btn-circle"
                  >
                    <FaArrowRight />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4 col-sm-6" data-aos="fade-down">
              <div className="card border-dark">
                <div className="card-body text-center p-4 p-xxl-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="currentColor"
                    className="bi bi-gear text-red mb-4"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.828 8.9 8.9 1.827a4 4 0 1 1 5.657 5.657l-7.07 7.071A4 4 0 1 1 1.827 8.9Zm9.128.771 2.893-2.893a3 3 0 1 0-4.243-4.242L6.713 5.429z" />
                  </svg>
                  <h4 className="mb-4">Control Systems Design</h4>
                  <p className="mb-4 text-secondary fs-6">
                    Advanced and reliable systems to enhance operational
                    control.
                  </p>
                  <a
                    href="#!"
                    className="btn btn-outline-danger bsb-btn-circle"
                  >
                    <FaArrowRight />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4" data-aos="fade-left">
              <div className="card border-dark">
                <div className="card-body text-center p-4 p-xxl-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="currentColor"
                    className="bi bi-tools text-red mb-4"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708" />
                  </svg>
                  <h4 className="mb-4">Maintenance & Support</h4>
                  <p className="mb-4 text-secondary fs-6">
                    Ensuring your systems run smoothly, 24/7.
                  </p>
                  <a
                    href="#!"
                    className="btn btn-outline-danger bsb-btn-circle"
                  >
                    <FaArrowRight />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 d-flex justify-content-center">
              <div
                className="row gy-3 gy-md-4"
                style={{ maxWidth: "960px" }}
                data-aos="fade-up"
              >
                <div className="col-12 col-md-6 col-lg-6">
                  <div className="card border-dark">
                    <div className="card-body text-center p-4 p-xxl-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        fill="currentColor"
                        className="bi bi-briefcase text-red mb-4"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
                      </svg>
                      <h4 className="mb-4">Consulting Services</h4>
                      <p className="mb-4 text-secondary fs-6">
                        Expert guidance for optimizing industrial processes.
                      </p>
                      <a
                        href="#!"
                        className="btn btn-outline-danger bsb-btn-circle"
                      >
                        <FaArrowRight />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6">
                  <div className="card border-dark">
                    <div className="card-body text-center p-4 p-xxl-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        fill="currentColor"
                        className="bi bi-battery-full text-red mb-4"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 6h10v4H2z" />
                        <path d="M14 9V7a1 1 0 0 1 1-1v4a1 1 0 0 1-1-1z" />
                      </svg>
                      <h4 className="mb-4">Energy Efficiency</h4>
                      <p className="mb-4 text-secondary fs-6">
                        Sustainable automation that reduces energy consumption.
                      </p>
                      <a
                        href="#!"
                        className="btn btn-outline-danger bsb-btn-circle"
                      >
                        <FaArrowRight />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Services */}
      <section className="margin_top bg-light">
        <div className="container">
          <div className="section-header mb-2">
            <h2 className="section-title text-red">
              Our <span className="text-yellow">Services</span>
            </h2>
          </div>

          <p className="mb-4 fs-6">
            <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
            offers expert automation, industrial solutions, digital
            transformation, process optimization, and smart technology services
            for businesses.
          </p>
        </div>
        <div className="container text-center">
          {/* Top Card */}
          <div className="row justify-content-center mb-4">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div className="card shadow-sm h-100 card_animation card1">
                <div className="card-body p-3">
                  <div
                    className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                    style={{
                      width: "65px",
                      height: "65px",
                    }}
                  >
                    <img
                      src={require("../assets/img/Home/serv-4.png")}
                      alt=""
                      style={{ width: "50px" }}
                    />
                  </div>
                  {/* icon */}
                  <h5>Industrial Automation</h5>
                  <p className="small text-muted">
                    Streamline industrial processes with advanced automation
                    systems.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Left + Center + Right */}
          <div className="row align-items-center justify-content-around mb-4">
            {/* Left Card */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div className="card shadow-sm h-100 card_animation card2">
                <div className="card-body p-3">
                  <div
                    className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                    style={{
                      width: "65px",
                      height: "65px",
                    }}
                  >
                    <img
                      src={require("../assets/img/Home/serv-3.png")}
                      alt=""
                      style={{ width: "50px" }}
                    />
                  </div>
                  <h5>Digital Transformation</h5>
                  <p className="small text-muted">
                    Modernize workflows and boost operational efficiency
                    digitally.
                  </p>
                </div>
              </div>
            </div>

            {/* Center Content */}
            <div className="col-12 col-md-4 col-lg-4 mb-4">
              <h2 className="section-title text-red">
                {/* Our <span className="text-yellow">Services</span> */}
              </h2>
              <p className="text-muted my-4">
                <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
                provides innovative automation and technology solutions designed
                to improve efficiency, productivity, and business growth.
              </p>
            </div>

            {/* Right Card */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div className="card shadow-sm h-100 card_animation card3">
                <div className="card-body p-3">
                  <div
                    className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                    style={{
                      width: "65px",
                      height: "65px",
                    }}
                  >
                    <img
                      src={require("../assets/img/Home/serv-1.png")}
                      alt=""
                      style={{ width: "50px" }}
                    />
                  </div>
                  <h5>Process Optimization</h5>
                  <p className="small text-muted">
                    Improve business performance and eliminate workflow
                    bottlenecks.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Cards */}
          <div className="row justify-content-center gap-5">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div className="card shadow-sm h-100 card_animation card4">
                <div className="card-body p-3">
                  <div
                    className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                    style={{
                      width: "65px",
                      height: "65px",
                    }}
                  >
                    <img
                      // src={require("../assets/img/Home/service-5.png")}
                      alt=""
                      style={{ width: "50px" }}
                    />
                  </div>
                  <h5>Smart Manufacturing</h5>
                  <p className="small text-muted">
                    Integrate AI and IoT for intelligent production.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div className="card shadow-sm h-100 card_animation card5">
                <div className="card-body p-3">
                  <div
                    className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3 achievement-icon"
                    style={{
                      width: "65px",
                      height: "65px",
                    }}
                  >
                    <img
                      src={require("../assets/img/Home/serv-2.png")}
                      alt=""
                      style={{ width: "50px" }}
                    />
                  </div>
                  <h5>Consulting & Support</h5>
                  <p className="small text-muted">
                    Expert guidance and ongoing technical support for growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section
        className="banner-section position-relative text-center text-white d-flex align-items-center margin_top"
        style={{
          minHeight: "60vh", // reduced height
          backgroundImage: `url(${require("../assets/img/Home/Banner.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div
          className="overlay position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }} // slightly lighter overlay
        ></div>

        {/* Banner Content */}
        <div className="container position-relative d-flex flex-column justify-content-center align-items-center text-center">
          <h2 className="text-white fw-bold mb-2 fs-2 fs-md-1">
            Leading Industrial Automation & Technology Solutions Provider
          </h2>
          <p className="lead text-white fs-6 mb-3 mb-md-4 mt-3">
            Skimitar Hindusthan Pvt Ltd delivers innovative automation, digital
            transformation, and smart manufacturing solutions for industries
            like automotive, electronics, textiles, food, and machinery. We help
            businesses streamline operations, reduce costs, and achieve
            sustainable growth.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-2">
            <button
              className="button-color btn"
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
